import React, { Component } from "react";
import Fade from "react-reveal/Fade";

import eAcademyLogo from "../../assets/img/logo/logo-colors.svg";
import yesserLogo from "../../assets/img/logo/Yesser-logo.svg";
import Facebook from "../../assets/img/social-media/facebook.svg";
import Youtube from "../../assets/img/social-media/youtube.svg";
import Twitter from "../../assets/img/social-media/twitter.svg";
import Linkedin from "../../assets/img/social-media/linkedin.svg";

import "./Footer.css";

export default class Footer extends Component {
  render() {
    return (
      <footer id="footer" className="footer">
        <div className="footer-overlay" />

        <div className="columns">
          <Fade>
            <div className="column is-3 column-one">
              <div className="footer-logo">
                <img
                  src={eAcademyLogo}
                  alt="e-gov academy logo"
                  className="footer-logo-one"
                />
                <img
                  src={yesserLogo}
                  alt="yesser logo"
                  className="footer-logo-two"
                />
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="column is-3 copy-right column-two">
              <div className="copy-content mt-2 has-text-centered">
                <p className="has-text-white">أكاديمية الحكومة الرقمية</p>
                <p className="copy has-text-white">
                  جميع الحقوق محفوظة
                  {" \xA9"} <span> {new Date().getFullYear()} </span>{" "}
                </p>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="column is-2 column-three">
              <h3 className="mt-2">تابعنا عبر</h3>
              <div className="social-icon mt-2">
                <a
                  href="https://www.facebook.com/YesserProgram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Facebook} alt="facebook" />{" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UC75mC9-H7QrJmrEzPRkpX4Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Youtube} alt="youtube" />{" "}
                </a>
                <a
                  href="https://twitter.com/YesserProgram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Twitter} alt="twitter" />{" "}
                </a>
                <a
                  href="https://www.linkedin.com/company/e-government-program-yesser-"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Linkedin} alt="linkedin" />{" "}
                </a>
              </div>
            </div>
          </Fade>
        </div>
      </footer>
    );
  }
}
